import React, {useEffect, useState} from "react";
import style from "../Content.module.css";

import info from "../../../assets/info.png";
import register from "../../../assets/register.png";
import {NavLink} from "react-router-dom";

export const About = (props) => {

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        window.onscroll = function() {
            let posTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
            if (posTop > 150 && posTop < 350) {
                setShowModal(true);
                window.onscroll = null;
            }
        }
    }, [])

    const modal = (
      <div className={style.modal}>
          <div className={style.modalBlocks}>
              <div className={style.modalIcon}>
                  <i className="fa fa-times" aria-hidden="true" onClick={() => setShowModal(false)}> </i>
              </div>
              <div className={style.modalInfo}>
                  <p>
                      <span>Пожалуйста</span>,
                      обратите внимание :)
                  </p>
                  <p> Весь мой практический опыт в качестве web-разработчика
                      можно посмотреть перейдя по ссылке "проекты" в меню,
                      либо нажав на эту кнопку:
                  </p>
                      <div className={style.btnProject}>
                          <NavLink to='/projects'>
                            <i className="fa fa-angle-double-right" aria-hidden="true"><p>Проекты</p></i>
                          </NavLink>
                      </div>
              </div>
          </div>
      </div>
    );

    return (
      <>
        <div className={style.mainWrapper}>
            <div className={style.EXPIRIENCE}>
                <div className={`${style.experienceBlock} ${style.infoBlocks}`}>
                    <div className={style.nameBlock}>ОБЩАЯ ИНФОРМАЦИЯ</div>
                    <img src={info} className={style.img}/>
                </div>

                <div className={`${style.content} ${style.experience}`}>
                    <p>
                        Меня зовут Артур, мне 23 года. Проживаю в городе Минск.
                        Имею техническое средне-специальное образование, на данный момент являюсь студентом 5 курса университета.
                        Учусь заочно, на факультете международного права и юридической психологии.
                    </p>
                    <br/>
                    <p>
                        Ориентированный на результат, скурпулезный начинающий веб-разработчик
                        с некоммерческим опытом создания различных веб-приложений,
                        использующих HTML, CSS, JavaScript, React, Redux и другие технологии.
                    </p>
                    <br/>
                    <p>
                        Изучением вышеперечисленного стека технологий занимаюсь с середины 2019 года.
                        Впервые проникся веб-разработкой при попытке подключить сторонние сервисы для клиента (CRM).
                        С того времени, регулярно занимаюсь самообразованием в сфере.
                        Меня не пугают сложные задачи и чем больше я узнаю о работе веб-приложений, тем
                        больший интерес во мне они вызывают :)

                        На момент написания этого портфолио могу самостоятельно создавать fullstack приложения с уровнем сложности - до среднего,
                        используя в разработке популярные библиотеки, которые часто используются в продакшене.
                    </p>
                    <br/>
                    <p>
                        Английский язык знаю на невысоком уровне и уже в процессе фикса этого бага :)
                    </p>
                    <br/>
                    <p>
                        Считаю, что моего уровня знаний достаточно, чтобы начать карьеру в веб-разработке, в качестве
                        junior web-developer.
                    </p>
                    <br/>
                    <h4>Технологии, которые использовал в связке с React: </h4>
                    <ul className={style.tehnologies}>
                        <li>Redux (thunk, custom middleware)</li>
                        <li>TypeScript</li>
                        <li>Node.js</li>
                        <li>MongoDB</li>
                        <li>Firebase</li>
                        <li>SASS</li>
                    </ul>

                </div>
            </div>
            <div className={style.FORMATION}>
                <div className={`${style.formationBlock} ${style.infoBlocks}`}>
                    <div className={style.nameBlock}>ОПЫТ РАБОТЫ</div>
                    <img src={register} className={style.img}/>
                </div>
                <div className={`${style.content} ${style.experience}`}>
                    <h3>CRM-интегратор</h3>
                    <br/>
                    <p>
                        Период работы: Январь 2018 - по настоящее время (2 года 6 месяцев)
                    </p>
                    <br/>
                    <h4>
                        Зона ответственности
                    </h4>
                    <br/>
                    <ul className={style.ul}>
                        <li>Обработка входящих заявок от клиентов</li>
                        <li>Ведение очных и удаленных переговоров на тему необходимости внедрения CRM-системы</li>
                        <li>Аудит различных отделов внутри компании-клиента</li>
                        <li>Составление ТЗ</li>
                        <li>Настройка имеющихся у клиента ресурсов, включая прямые интеграции (веб-приложения собранные на различных конструкторах, самописные решения и т.д)</li>
                        <li>Написание материала для ознакомления сотрудников с функционалом и очное обучение</li>
                    </ul>

                </div>
            </div>
        </div>
          {showModal ? modal : null}
      </>
    )
}